import React, {Fragment, useState, useEffect} from 'react'
import ReactDOM from 'react-dom'
import {
  useParams
} from 'react-router-dom'
import axios from 'axios';
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';
import Slider from "react-slick";
import { ItemSlider } from '../components/ItemSlider';
import { Filtro } from '../components/Filtro';

export const Sectores = (props) => {

    const fakeCategorias = [{title:'Fake data etiqueta'}]
    const [listaEventos, setListaEventos] = useState(false)
    const urlparams = useParams() 

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

      const fetchListaEventos = async () => {
        let urlapi = `${process.env.REACT_APP_URL_API}formatos/obtenerformatopublico`
        let dataFormEventos = {  
            "formato": "sectores",
            "idCategoria": urlparams.id
        }
        if(props.isAuth){
            urlapi= `${process.env.REACT_APP_URL_API}formatos/obtenerformato`
            dataFormEventos = {  
                "formato": "sectores",
                "idCategoria": urlparams.id,
                "idUsuario": 5
            }
        }
        
        
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
            },  
        };
        
        axios.post(urlapi, dataFormEventos, axiosConfig)
        .then((res) => {

            setListaEventos(res.data.data)
        })
        .catch((err) => {
            
        }) 
    }

    useEffect(() => {
        fetchListaEventos();
    },[urlparams.id])

    if(!listaEventos) { return(<div></div>) } 
   

    return(
        <Fragment>
            <Cabecera imagen={true} top={false} removeAuth={props.removeAuth} datosCabecera={listaEventos} />
            <section className="py-5">
                <div className="container">
                <Filtro />
                <div className="row first-row">
                    <div className="col-md-12">

                    {
                        listaEventos.map(item =>
                         <Fragment>
                         {item.idZona === 3 && 
                            <div key={Math.random() * 57005} className="contenedor-slider" >
                                <div className="titulo">{item.titulo}</div>
                                <div className="listadoItems">
                                  
                                    { item.eventos.map(evento =>
                                        <div key={Math.random() * 57005}>
                                            <div className="caja">
                                                <ItemSlider evento={evento} eventosInscritos={item.eventosInscritos} />
                                            </div>
                                        </div>
                                    )}

                                   
                                </div>
                            </div>
                         }
                        </Fragment>
                        )}
                    </div>
                </div>
                </div> 
            </section>
            <Footer />
        </Fragment>
    )

}